import { Email, Inbox, MSTeams, Push, Slack, SMS } from "./Channels";
export { BrandFooter } from "@/components/BrandEditor/Editor/BrandFooter";
export { useChannels, getChannelDefaults } from "./Channels";
export { default as EmailEditor } from "./Channels/Email/EmailEditor";
export * from "./TemplateEditor";

export {
  SideBar as EmailSideBar,
  SideBarItemDetails as EmailSideBarItemDetails,
} from "./Channels/Email/SideBar";
export { SideBar as InboxSideBar } from "./Channels/Inbox/SideBar";
export { MSTeamsSideBar, MSTeamsSideBarItemDetails } from "./Channels/MSTeams/SideBar";
export { SlackSideBar, SlackSideBarItemDetails } from "./Channels/Slack/SideBar";

// Document-level email style controls, so a host that supplies its own `render`
// (studio's email channel does) gets the same Frame / base-typography fields as
// the built-in EmailLayout instead of reimplementing them.
export {
  EmailBaseTypographyFields,
  EmailBodyFrame,
  EmailFramePaddingFields,
  type EmailDocumentStyles,
} from "./Channels/Email/EmailDocumentStyleFields";

// Pure resolver for read-only surfaces that render a stored version of a
// template rather than the live editor state (e.g. version comparison).
export {
  resolveEmailDocumentStyles,
  type EmailChannelDocumentStyles,
} from "./hooks/useEmailDocumentStyles";

export {
  EmailEditorContainer,
  EmailEditorMain,
  type EmailEditorProps,
  type InboxEditorProps,
  type MSTeamsEditorProps,
  type PushEditorProps,
  type SlackEditorProps,
  type SMSEditorProps,
} from "./Channels";

export const EmailChannel = Email;
export const SMSChannel = SMS;
export const PushChannel = Push;
export const InboxChannel = Inbox;
export const MSTeamsChannel = MSTeams;
export const SlackChannel = Slack;

export { ChannelRootContainer, EditorSidebar } from "./Layout";
export {
  isSidebarExpandedAtom,
  availableVariablesAtom,
  variablesEnabledAtom,
  variableValidationAtom,
  sampleDataAtom,
  EMAIL_DEFAULT_BACKGROUND_COLOR,
  EMAIL_DEFAULT_CONTENT_BODY_COLOR,
  emailFontFamilyAtom,
} from "./store";
export { InboxEditor, MSTeamsEditor, PushEditor, SlackEditor, SMSEditor } from "./Channels";

export { useDebouncedFlush } from "./hooks/useDebouncedFlush";
